const AnnouncementPublishTab = {
  PUBLISHED: 'PUBLISHED',
  SCHEDULED: 'SCHEDULED',
};

export {
  AnnouncementPublishTab,
};
